import React, { useEffect, useMemo } from 'react';
import { Navigate,Route, Routes } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Box from "@mui/material/Box";
import { UserRoles } from 'src/constants/user';

import { RootModal } from "./components/Modal/RootModal";
import { useAppSelector } from "./hooks/redux";
import { CreatePasswordAdminScreen } from "./screens/auth/CreatePasswordAdminScreen";
import { CreatePasswordEmployeeScreen } from "./screens/auth/CreatePasswordEmployeeScreen";
import { NavBar, SideBar } from "./components";
import {
  AdminsScreen,
  AnalyticsScreen,
  BookingsScreen,
  CustomersScreen,
  EmployeesScreen,
  ResetPasswordScreen,
  ServicesScreen,
  SetNewPasswordScreen,
  SettingsScreen,
  SignInScreen,
  StudiosScreen,
  WorkingTimeScreen,
} from "./screens";
import { theme } from "./theme";

function App () {
  // todo update router basic on userRole
  // todo unify router object to, path, icons, screens, title etc. to easy generation routing object basic on userRole

  const { user, isLoggedIn } = useAppSelector((state) => state.auth);

  const SignedInRoutes = useMemo(() => {
    // @ts-ignore
    const role = UserRoles[user?.role];

    switch (role) {
      case UserRoles.SUPER_ADMIN:
        return (
          <Routes>
            <Route path="*" element={<AdminsScreen />} />
            <Route path="/employees" element={<EmployeesScreen />} />
            <Route path="/studios" element={<StudiosScreen />} />
            <Route path="/services" element={<ServicesScreen />} />
            <Route path="/bookings" element={<BookingsScreen />} />
            <Route path="/schedule-template" element={<WorkingTimeScreen />} />
          </Routes>
        );
      case UserRoles.ADMIN:
        return (
          <Routes>
            <Route path="*" element={<Navigate to="/employees" />} />
            <Route path="/employees" element={<EmployeesScreen />} />
            <Route path="/studios" element={<StudiosScreen />} />
            <Route path="/services" element={<ServicesScreen />} />
            <Route path="/bookings" element={<BookingsScreen />} />
            <Route path="/schedule-template" element={<WorkingTimeScreen />} />
          </Routes>
        );
      case UserRoles.MASTER:
        return (
          <Routes>
            <Route path="*" element={<BookingsScreen />} />
          </Routes>
        );
      default:
        return (
          <Routes>
            <Route path="*" element={<BookingsScreen />} />
          </Routes>
        );
    }
  }, [user]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RootModal />
      {!isLoggedIn ? (
        // Auth Stack
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="100%"
          sx={{
            backgroundImage: "url('/images/sign-in-background.png')",
            backgroundSize: "cover",
          }}
        >
          <Routes>
            <Route path="*" element={<SignInScreen />} />
            <Route path="/reset" element={<ResetPasswordScreen />} />
            <Route path="/confirm" element={<CreatePasswordAdminScreen />} />
            <Route
              path="/add-master"
              element={<CreatePasswordEmployeeScreen />}
            />
            <Route
              path="/set-new-password"
              element={<SetNewPasswordScreen />}
            />
            <Route
              path="/restore-password"
              element={<SetNewPasswordScreen />}
            />
          </Routes>
        </Box>
      ) : (
        //Main App Stack
        <div className="app">
          <SideBar />
          <main className="content">
            <NavBar />

            {SignedInRoutes}

          </main>
        </div>
      )}
    </ThemeProvider>
  );
}

export default App;
